import { useAuth } from "@/context/AuthContext";

// Official ChitChat Local artwork (bundled default).
// Tenant branding (logo_url / icon_url) overrides for white-label tenants.
// Relative /api branding URLs are resolved against the backend origin.
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolve = (url, fallback) => {
  if (!url) return fallback;
  return url.startsWith("/api") ? `${BACKEND}${url}` : url;
};

export function Logo({ compact = false, className = "" }) {
  const { tenant } = useAuth() || {};
  const logoUrl = resolve(tenant?.logo_url, "/brand/logo.png");
  const iconUrl = resolve(tenant?.icon_url, "/brand/icon.png");
  if (compact) {
    return <img src={iconUrl} alt="ChitChat" className={`h-9 w-9 object-contain ${className}`} data-testid="cc-logo" />;
  }
  return <img src={logoUrl} alt={tenant?.name || "ChitChat Local"} className={`h-8 sm:h-9 w-auto object-contain ${className}`} data-testid="cc-logo" />;
}
